import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  height: 63vh;
  overflow-y: auto;
`;

export const Tab = styled.div`
`;